import React, { useState, useEffect, useCallback } from 'react';
import Reveal from './Reveal';
import poems from '../data/poems';
import './WrittenWorks.css';

const writtenWorks = [
  {
    id: 1,
    title: 'Publicação em Jornal',
    description: 'Textos e poesias publicados com lirismo e crítica social, destacando a identidade cultural brasileira.',
    image: '/jornal.jpeg',
    type: 'Jornal'
  },
  {
    id: 2,
    title: 'Cartaz e Mural Cultural',
    description: 'Trabalhos literários e artísticos expostos em espaços culturais, promovendo a arte e a cultura.',
    image: '/muralespacodasartes.jpeg',
    type: 'Mural'
  }
];

const excerpt = (text, lines = 4) => text.split('\n').filter(Boolean).slice(0, lines);

const WrittenWorks = () => {
  const [active, setActive] = useState(null);
  const close = useCallback(() => setActive(null), []);

  useEffect(() => {
    if (!active) return;
    const onKey = (e) => e.key === 'Escape' && close();
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [active, close]);

  return (
    <section id="written-works" className="written-works section">
      <div className="container">
        <Reveal>
          <span className="section-eyebrow">Poesia &amp; literatura</span>
          <h2 className="section-title">Textos &amp; Poesia</h2>
          <p className="section-subtitle">
            Uma escrita marcada por lirismo, crítica social e forte identidade cultural
            brasileira. Leia as poesias aqui mesmo ou baixe o original em PDF.
          </p>
        </Reveal>

        {/* ---- Poesias ---- */}
        <div className="poems-grid">
          {poems.map((poem, index) => (
            <Reveal as="article" key={poem.id} className="poem-card" delay={(index % 4) * 80}>
              <div className="poem-card-top">
                <span className="poem-tag">Poesia</span>
                {poem.isNew && <span className="poem-new">Nova</span>}
              </div>
              <h3 className="poem-title">{poem.title}</h3>
              <p className="poem-excerpt">
                {excerpt(poem.text).map((line, i) => (
                  <span key={i}>{line}<br /></span>
                ))}
              </p>
              <div className="poem-actions">
                <button className="poem-read" onClick={() => setActive(poem)}>
                  Ler a poesia completa →
                </button>
                <a href={poem.pdf} target="_blank" rel="noopener noreferrer" className="poem-pdf">
                  PDF
                </a>
              </div>
            </Reveal>
          ))}
        </div>

        {/* ---- Publicações ---- */}
        <div className="written-works-grid">
          {writtenWorks.map((work, index) => (
            <Reveal key={work.id} className="written-work-card" delay={index * 90}>
              <div className="work-image-container">
                <img
                  src={work.image}
                  alt={work.title}
                  className="work-image"
                  loading="lazy"
                />
                <span className="work-type">{work.type}</span>
              </div>
              <div className="work-info">
                <h3 className="work-title">{work.title}</h3>
                <p className="work-description">{work.description}</p>
              </div>
            </Reveal>
          ))}

          <Reveal className="written-work-card written-work-pdf" delay={180}>
            <div className="work-pdf-container">
              <span className="pdf-tag">PDF</span>
              <h3 className="work-title">Poesias Completas</h3>
              <p className="work-description">
                Coleção de poesias que expressam lirismo, crítica social e
                a força das raízes culturais brasileiras.
              </p>
              <a href="/poesia.pdf" target="_blank" rel="noopener noreferrer" className="btn btn-ghost">
                Baixar a coletânea
              </a>
            </div>
          </Reveal>
        </div>

        <Reveal className="editor-card">
          <div className="editor-accent" aria-hidden="true"></div>
          <div className="editor-content">
            <span className="editor-label">Editora Cristal Music</span>
            <blockquote className="editor-message">
              “A Cristal Music celebra a nova parceria com o autor Varella, unindo forças
              para potencializar sua trajetória e levar suas composições a novos públicos.
              Seja muito bem-vindo, Varella!”
            </blockquote>
          </div>
        </Reveal>
      </div>

      {active && (
        <div className="poem-modal" role="dialog" aria-modal="true" aria-label={active.title} onClick={close}>
          <button className="poem-modal-close" onClick={close} aria-label="Fechar">×</button>
          <div className="poem-modal-inner" onClick={(e) => e.stopPropagation()}>
            <span className="poem-tag">Poesia</span>
            <h3 className="poem-modal-title">{active.title}</h3>
            <p className="poem-modal-epigraph">({active.epigraph})</p>
            <p className="poem-modal-author">Autor: Antônio Varella — Varella Sambista</p>
            <div className="poem-modal-text">{active.text}</div>
            <a href={active.pdf} target="_blank" rel="noopener noreferrer" className="btn btn-ghost poem-modal-pdf">
              Abrir o original (PDF)
            </a>
          </div>
        </div>
      )}
    </section>
  );
};

export default WrittenWorks;
